import { Layout } from "@/components/layout";
import { About, Guide, Home, Location, Rooms, Specials } from "@/domains";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/home",
                element: <Home />,
            },
            {
                path: "/about",
                element: <About />,
            },
            {
                path: "/location",
                element: <Location />,
            },
            {
                path: "/rooms/:roomIdx",
                element: <Rooms />,
            },
            {
                path: "/specials/:specialIdx",
                element: <Specials />,
            },
            {
                path: "/guide",
                element: <Guide />,
            },
        ],
    },
]);

export default router;

// {...FONT("pretendard", 24, 600, 1.4)} {...FONT("pretendard", 16, 400, 1.4)} {...FONT("pretendard", 16, 400, 1.4)}}
